import TemplateTimeline from ".";
import SpaceTemplateMembers from "../SpaceTemplateMembers";
import TemplateHistory from "../TemplateHistory/TemplateHistory";
import TemplateReorder from "../TemplateReorder";
import TemplateSpaceEdit from "../TemplateSpaceEdit";

export const templateRoutes = [
  {
    path: "/space_templates/:id/posts",
    exact: true,
    main: TemplateTimeline,
  },
  {
    path: "/space_templates/:id/posts/reorder",
    exact: true,
    main: TemplateReorder,
  },
  {
    path: "/space_templates/:id/history",
    exact: true,
    main: TemplateHistory,
  },
  {
    path: "/space_templates/:id/edit",
    exact: true,
    main: TemplateSpaceEdit,
  },
  {
    path: "/space_templates/:id/members",
    exact: true,
    main: SpaceTemplateMembers,
  },
];
